import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = window.location.hash.match(/session_id=([^&]+)/);
    const sid = m && m[1];
    (async () => {
      try {
        if (sid) await api.post("/auth/session", { session_id: decodeURIComponent(sid) });
      } catch (e) { /* ignore */ }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/pilih", { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto rounded-full border-2 border-amber-400/30 border-t-amber-300 animate-spin mb-4" />
        <p className="text-sm text-gray-400 font-mono">Nyiapin Ruang Kendali lo...</p>
      </div>
    </div>
  );
}
